import { render } from "./Hosts.vue?vue&type=template&id=57a6b64a&scoped=true"
import script from "./Hosts.vue?vue&type=script&lang=js"
export * from "./Hosts.vue?vue&type=script&lang=js"

import "./Hosts.vue?vue&type=style&index=0&id=57a6b64a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vertex/vertex/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a6b64a"]])

export default __exports__